import { liveSearchParams } from '@features/map/liveSearchParams'
import { useNavigate, useSearchParams } from 'react-router'
import { Enum } from 'utils'

export enum DealerMapTab {
  ActiveDevices = 'activeDevices',
  MyData = 'myData'
}

/** Absent means {@link DealerMapTab.ActiveDevices}. */
export const DEALER_TAB_PARAM = 'dealerTab'

/**
 * The dealership map's active tab, in the URL so a return from a field can land
 * on a specific one.
 */
export const useDealerMapTab = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const raw = searchParams.get(DEALER_TAB_PARAM)
  const tab = Enum.isValidValue(raw, DealerMapTab) ? raw : DealerMapTab.ActiveDevices

  const setTab = (next: DealerMapTab) => {
    const params = liveSearchParams()
    if (next === DealerMapTab.ActiveDevices) {
      params.delete(DEALER_TAB_PARAM)
    } else {
      params.set(DEALER_TAB_PARAM, next)
    }
    navigate({ search: params.toString() }, { replace: true })
  }

  return { tab, setTab }
}
